module.exports = __webpack_public_path__ + "static/img/first_image.3d5fa7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/first_image.png
// module id = 509
// module chunks = 1